import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ['dropdown']
  static values = { baseUrl: String, key: String, blankParamWhenEmpty: Boolean }

  itemSelected() {
    const url = new URL(this.baseUrlValue, location)
    const selectedItems = this.element.slim.getSelected()
    if (selectedItems.length > 0) {
      url.searchParams.set(this.keyValue, selectedItems)
    } else if (this.blankParamWhenEmptyValue) {
      url.searchParams.set(this.keyValue, "") // send fieldName= when no option is selected
    } else {
      url.searchParams.delete(this.keyValue)
    }
    window.location.href = url
  }
}
